import { useMemo } from "react";

import moment from "moment";

import { useSelectedCycle } from "./use-selected-cycle";

export const useSelectedCyclePreviousPeriod = () => {
  const { selectedCycle } = useSelectedCycle();

  return useMemo(() => {
    const currentCycleStart = moment(selectedCycle.date_range.start_date);
    const currentCycleEnd = moment(selectedCycle.date_range.end_date);
    const daysDiff = currentCycleEnd.diff(currentCycleStart, "days");

    const yesterday = moment().subtract(1, "days");
    let endDate = moment(currentCycleStart).subtract(1, "days");

    if (endDate.isAfter(yesterday)) {
      endDate = yesterday;
    }

    const startDate = moment(endDate).subtract(daysDiff, "days");

    return {
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
    };
  }, [selectedCycle]);
};
